module.exports = __webpack_public_path__ + "bb2df960c0d92df3d1a37c2dd3957ac6.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/svg/circle-46.svg
// module id = 580
// module chunks = 0